import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { IStatePerson } from "@/apps/merchant3/models/IStatePerson";

export default {
  namespaced: true,
  state: {
    location: null,
    userType: null,
    userTag: null,
    versionHash: null,
    userData: {
      termsAndConditionsAccept: null,
      privacyPolicyAccept: null,
      frontImageURL: null,
      backImageURL: null,
      selfieImageURL: null,
      proofOfAddressImageURL: null,
      phoneNumber: null,
      email: null,
      phoneVerify: null,
      country: null,
    },
  } as IStatePerson,

  mutations,
  actions,
  getters,
};
